export const environment = {
    production: true,
    appUrl: 'https://staging.account.dataedo.com/',
    apiUrl: 'https://staging.api.account.dataedo.com/api/',

    websiteUrl: 'https://staging.dataedo.com/',
    supportMailAddress: 'testmailbox@dataedo.com',
};
